import { Component } from '@angular/core';
import { GoogleAnalyticsService } from '@shared/services';

@Component({
  selector: 'dls-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  constructor(private _googleAnalyticsService: GoogleAnalyticsService,) { }

  captureClick(event) {
    const title: string = event.currentTarget.innerText;
    this._googleAnalyticsService.trackPageEvents('click', title.toUpperCase());
  }
}
